import { Outlet } from 'react-router-dom';
import { Navigation } from './Navigation';
// Temporarily disabled due to Vite module resolution issue
// import { ChatPanel, ChatToggleButton } from '../Chat';

export function MainLayout() {
  return (
    <div className="min-h-screen bg-obsidian flex flex-col">
      <Navigation />
      <main className="flex-1 flex flex-col overflow-hidden">
        <Outlet />
      </main>

      {/* Chat Interface - Temporarily disabled */}
      {/* <ChatToggleButton /> */}
      {/* <ChatPanel /> */}
    </div>
  );
}
